module.exports = __webpack_public_path__ + "static/media/fish_cn.241b6452.png";